import { render } from "./Tab1Form.vue?vue&type=template&id=5d82b61e"
import script from "./Tab1Form.vue?vue&type=script&lang=js"
export * from "./Tab1Form.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__